export const externalLinks = {
  privacyNotice: "https://www.zamna.com/privacy-notice/?lang={{lang}}",
  paxWebpage: "https://www.zamna.com/pax/?lang={{lang}}",
  homePage: "https://www.iberojet.com/",
};

export default externalLinks;
